import { render, staticRenderFns } from "./ProjectRoleRuleList.vue?vue&type=template&id=e51b1b30&"
import script from "./ProjectRoleRuleList.vue?vue&type=script&lang=js&"
export * from "./ProjectRoleRuleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports